module.exports = __webpack_public_path__ + "8bf3ee0987255685f30d24b8b6880d3d.svg";